import React from 'react'

import useAxios from 'hooks/useAxios'
import IntercomCreateFollowupConversationIntegration from '.'
import { Loader } from 'shared/components/Loader'

export default function IntercomCreateFollowupConversationIntegrationContainer({
  updateCompanyIntegrationSetting,
  updateCompanyIntegrationSettingAPILoading,
  isAuthenticated,
  integrationSetting,
}) {
  const { data: surveyIntegrationSettings } = useAxios({
    url: 'survey/survey-integration-setting/by-integration/?integration_type=intercom&name=push_follow_up_conversation',
  })

  function activateIntegration() {
    updateCompanyIntegrationSetting(integrationSetting, true)
  }
  function deactivateIntegration() {
    updateCompanyIntegrationSetting(integrationSetting, false)
  }

  if (!surveyIntegrationSettings) {
    return <Loader withContainer />
  }

  return (
    <IntercomCreateFollowupConversationIntegration
      integrationSetting={integrationSetting}
      updateCompanyIntegrationSettingAPILoading={updateCompanyIntegrationSettingAPILoading}
      isAuthenticated={isAuthenticated}
      surveyIntegrationSettings={surveyIntegrationSettings}
      activateIntegration={activateIntegration}
      deactivateIntegration={deactivateIntegration}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntercomCreateFollowupConversationIntegration/container.js